__turbopack_context__.v({
  "className": "jetbrains_mono_2542152e-module__el04hq__className",
  "variable": "jetbrains_mono_2542152e-module__el04hq__variable",
});
